"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _InputSelect = _interopRequireDefault(require("@kiwicom/orbit-components/lib/InputSelect"));
var _getIATALocations = require("./services/getIATALocations");
var _context = require("../../../../services/intl/context");
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IataPicker = _ref => {
  let {
    id,
    value,
    error,
    intl,
    onSelect
  } = _ref;
  const [state, setDataState] = React.useState({
    step: "init"
  });
  const [inputValue, setInputValue] = React.useState(value);
  const {
    language
  } = (0, _context.useIntl)();
  React.useEffect(() => {
    (0, _getIATALocations.getIATALocations)(inputValue, language.iso).then(locations => {
      setDataState({
        step: "data",
        data: locations
      });
    }).catch(() => {
      setDataState({
        step: "error",
        data: []
      });
    });
  }, [inputValue, language.iso]);
  return state.step === "init" ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "relative",
    "data-test": "MagicLogin-IATAPicker",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputSelect.default, {
      id: id,
      dataTest: "MagicLogin-IATAPickerInput",
      label: intl.formatMessage({
        id: "common.iata_code"
      }),
      labelClear: intl.formatMessage({
        id: "common.screenreader.clear_value.button"
      }),
      placeholder: intl.formatMessage({
        id: "account.iata_placeholder"
      }),
      help: intl.formatMessage({
        id: "account.iata_help"
      }),
      error: error,
      emptyState: state.step === "error" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
        type: "critical",
        labelClose: intl.formatMessage({
          id: "orbit.button_close"
        }),
        children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "common.api_error"
        }))
      }) : null,
      options: state.data,
      defaultSelected: value ? state.data.find(option => option.value === value) : undefined,
      onChange: ev => {
        setInputValue(ev.currentTarget.value || "");
      },
      onOptionSelect: option => {
        onSelect(option === null || option === void 0 ? void 0 : option.value);
      }
    })
  });
};
var _default = exports.default = (0, _reactIntl.injectIntl)(IataPicker);